export enum RebateSubmissionFileStatusModel {
	New = 1,
	WaitingForGenerating = 2,
	GeneratingFile = 3,
	FileGenerated = 4,
	Failed = 5,
	Submitting = 6,
	Submitted = 7,
	Finalizing = 8,
	Finalized = 9
}
